// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ns-carousel-item[data-v-518449d4]{position:relative}.ns-carousel-item.vertical[data-v-518449d4]> *{transform:rotate(-90deg)}", ""]);
// Exports
module.exports = exports;
